import { motion } from "framer-motion";
import { FaClock, FaTimes } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const TimePickerModal = ({ isOpen, onClose, setData, data }) => {
  const { t } = useTranslation("carrier");
  const { questId, zoneIndex, zone } = isOpen ?? {};
  // Find the data item by question_id
  const dataIndex = data?.findIndex(
    (d) => String(d.question_id) === String(questId)
  );
  const currentData = dataIndex !== -1 ? data[dataIndex] : undefined;

  return isOpen ? (
    <div className="fixed z-[9999] inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="bg-ui-surface p-6 rounded-2xl shadow-lg w-96"
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-ui-text">
            {t("zoneSettings.selectTimeRange")}
          </h2>
          <button
            onClick={onClose}
            className="text-ui-text-muted hover:text-state-danger-text"
          >
            <FaTimes size={18} />
          </button>
        </div>

        <div className="space-y-4">
          {/* From Time */}
          <label className="block text-sm font-medium text-ui-text">
            <div className="flex items-center gap-2 cursor-pointer">
              <FaClock className="text-brand" />
              {t("zoneSettings.fromTime")}
            </div>
            <input
              type="time"
              value={
                currentData?.zoneData[zoneIndex]?.availablity_time_from || ""
              }
              onChange={(e) =>
                setData((d) => {
                  return d.map((dItem) => {
                    if (String(dItem.question_id) === String(questId)) {
                      return {
                        ...dItem,
                        zoneData: dItem.zoneData.map((zdata, zIndex) => {
                          return zIndex === zoneIndex
                            ? {
                                ...zdata,
                                zone_id: zone.id,
                                availablity_time_from: e.target.value ?? "",
                              }
                            : zdata;
                        }),
                      };
                    } else {
                      return dItem;
                    }
                  });
                })
              }
              className="mt-1 w-full px-3 py-2 border border-ui-border rounded-lg focus:outline-none focus:ring-2 focus:ring-brand"
            />
          </label>

          {/* To Time */}
          <label className="block text-sm font-medium text-ui-text">
            <div className="flex items-center gap-2 cursor-pointer">
              <FaClock className="text-state-warning-text" />
              {t("zoneSettings.toTime")}
            </div>
            <input
              type="time"
              value={
                currentData?.zoneData[zoneIndex]?.availablity_time_to || ""
              }
              onChange={(e) =>
                setData((d) => {
                  return d.map((dItem) => {
                    if (String(dItem.question_id) === String(questId)) {
                      return {
                        ...dItem,
                        zoneData: dItem.zoneData.map((zdata, zIndex) => {
                          return zIndex === zoneIndex
                            ? {
                                ...zdata,
                                zone_id: zone.id,
                                availablity_time_to: e.target.value ?? "",
                              }
                            : zdata;
                        }),
                      };
                    } else {
                      return dItem;
                    }
                  });
                })
              }
              className="mt-1 w-full px-3 py-2 border border-ui-border rounded-lg focus:outline-none focus:ring-2 focus:ring-brand"
            />
          </label>
        </div>

        {/* Buttons */}
        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-sm rounded-md text-ui-text-muted bg-ui-surface-sunken hover:bg-ui-border transition"
          >
            {t("common:actions.cancel")}
          </button>
          <button
            onClick={() => {
              onClose();
            }}
            className="px-3 py-1.5 text-sm rounded-md text-white bg-ui-inverted hover:bg-black transition"
          >
            {t("common:actions.confirm")}
          </button>
        </div>
      </motion.div>
    </div>
  ) : null;
};

export default TimePickerModal;
